import { createDuck, createEntityCollection } from '@/utils'

import {
  getCartData,
  updateNumber,
  updateSelected,
  changeSku,
  delItem,
  getNotify,
  modifyActGoods,
  removeActGoods,
  getActivityIds,
} from '@/services/api/cart'

import { getRecommend } from '@/services/api/common'
import { isSelectAll, handleCartData, formatCartList } from '@/utils/cartUtils'
import { isObject } from '@/utils/utils'
import { Toast } from 'antd-mobile-v2'
import { SHOP_ID, ACTIVITY_TYPES } from '@/utils/const'
import { MAX_ACT_CART_COUNT } from '@/utils/cartConst'
export const duck = createDuck({
  name: 'cartDuck',
  /** @type cart.CartState */
  initialState: {
    status: 0,
    productCollection: null,
    expiredList: [],
    allSelectedIds: [],
    postage: null,
    recommendList: null,
    isSelectAll: false,
    notifyInfo: null,
    reportDatas: null,

    isEmpty: false,

    //换购数据
    activityCartGoods: null,
    activityGoods: null,
    activity: null,

    activityIds: null,
    stepCollection: null,

    stepDiscountActivity: null,
    // stepDiscountActivityGoods: [],
    errorCode: 0, // 错误码是 1003，购买商品种类不能超过50
  },

  actions: {
    initPageData() {
      return async dispatch => {
        dispatch(duck.fetchCartData())
        dispatch(duck.getNotify())
        dispatch(duck.getRecommendData())
      }
    },

    fetchCartData(hide = true) {
      //TODO 获取actiityId

      return async (dispatch, getState) => {
        let { activityIds = '' } = getState('cartDuck')

        const { data: actData, error: actErr } = await getActivityIds()
        if (!actErr) {
          activityIds = actData || ''
        }

        const { data, error } = await getCartData(SHOP_ID, activityIds)
        if (hide) {
          Toast.hide()
        }

        if (!error) {
          const {
            activityCartGoods,
            activityGoods,
            activity,
            stepDiscountActivity,
            stepDiscountActivityGoods: discountList,
            list,
            errorCode, // 增加一个字段，错误码是 1003 的时候，商品种类不能超过50
          } = data
          if (errorCode === 1003) {
            Toast.show('购买商品种类不能超过50')
          }
          const stepDiscountActivityGoods = Array.isArray(discountList) ? discountList : []
          const productCollection = createEntityCollection(formatCartList(list), x => x.subItemId)
          const stepsCollection = createEntityCollection(
            formatCartList(stepDiscountActivityGoods),
            x => x.subItemId,
          )
          const { selectedSubItemIds, reportDatas } = handleCartData(
            data.list,
            stepDiscountActivityGoods,
          )

          const _post = isObject(data.postage) ? data.postage : {}
          dispatch(
            duck.change({
              status: 1,
              productCollection: productCollection,
              expiredList: data.expired,
              postage: isObject(data.postage) ? data.postage : {},
              isSelectAll: isSelectAll(data.list, stepDiscountActivityGoods),
              allSelectedIds: selectedSubItemIds,
              reportDatas: reportDatas,
              activityIds,

              stepDiscountActivity: stepDiscountActivity ? stepDiscountActivity : {},

              stepCollection: stepsCollection,

              isEmpty: stepDiscountActivityGoods.length < 1 && list.length < 1,
              //换购数据

              activityCartGoods: Array.isArray(activityCartGoods) ? activityCartGoods : [],
              activityGoods: Array.isArray(activityGoods) ? activityGoods : [],
              activity: !activity
                ? {
                    state: -100,
                  }
                : {
                    ...activity,
                    canAddToActCart:
                      Array.isArray(activityCartGoods) &&
                      activityCartGoods.length < MAX_ACT_CART_COUNT,
                  },
              errorCode,
            }),
          )
        } else {
          Toast.info((error && error.message) || '获取购物车数据失败')
          dispatch(
            duck.change({
              status: 2,
            }),
          )
        }
      }
    },
    /**
     * 修改选中状态
     * @param {object} param
     * @param {Array[number]} param.subItemIds
     * @param {boolean} param.newStatus
     * @returns
     */
    updateSelectedStatus(param) {
      return async dispatch => {
        Toast.loading('loading...')
        const { error } = await updateSelected({
          ...param,
          shopId: SHOP_ID,
        })
        // Toast.hide()
        if (!error) {
          dispatch(duck.fetchCartData())
        } else {
          Toast.hide()
          alert(error.message)
        }
        //状态
      }
    },

    /**
     * 批量修改状态
     * @param {boolean} newStatus
     * @returns
     */
    updateAllStatus(newStatus) {
      return async (dispatch, getState) => {
        const { cartDuck } = getState()
        if (!cartDuck.allSelectedIds) return
        dispatch(
          duck.updateSelectedStatus({
            subItemIds: cartDuck.allSelectedIds,
            newStatus,
          }),
        )
      }
    },

    //修改数量
    /**
     *
     * @param {object} param
     * @param {number} param.subItemId
     * @param {number} param.count
     * @param {number} param.stockCount
     * @param {number} param.originCount
     * @param {boolean} param.selected
     * @returns
     */
    updateItemNumber(param) {
      return async dispatch => {
        Toast.loading('loading...')
        const { count, originCount, stockCount, selected, ...ot } = param

        const max = Math.min(100, stockCount)
        let v = count - originCount
        if (count > max) {
          v = max - originCount
        }
        const { error } = await updateNumber({
          ...ot,
          count: v,
          shopId: SHOP_ID,
          choice: selected ? true : false,
        })
        if (!error && count > max) {
          Toast.info('数量超过限制，已为你调整到最大可选值', 2)
          dispatch(duck.fetchCartData(false))
          return
        } else if (error) {
          Toast.info(error.message || '数量更新失败', 2)
          dispatch(duck.fetchCartData(false))
          return
        }

        dispatch(duck.fetchCartData())
      }
    },

    /**
     * 修改sku
     * @param {object} param
     * @param {object} param.oldSubItem
     * @param {object} param.targetSubItem
     * @returns
     */
    changeSku(param) {
      return async dispatch => {
        const { oldSubItem, targetSubItem } = param

        Toast.loading('loading...')
        const { error } = await changeSku({
          oldSubItemId: oldSubItem.id,
          targetSubItemId: targetSubItem.id,
          shopId: SHOP_ID,
        })
        if (!error) {
          //如果 修改之后的sku的库存 不足，自动修改数量，并给用户提示
          if (targetSubItem.stockCount < oldSubItem.count) {
            const { error: err } = await updateNumber({
              subItemId: targetSubItem.id,
              count: targetSubItem.stockCount - oldSubItem.count,
              shopId: SHOP_ID,
              choice: false,
            })
            if (!err) {
              Toast.info('数量超过限制，已为你调整到最大可选值', 2)
              dispatch(duck.fetchCartData(false))
              return
            }
          }
          dispatch(duck.fetchCartData())
        } else {
          Toast.hide()
          alert(error.message || '型号更新失败')
        }
      }
    },

    //本地修改
    changeSkuLocal() {},

    /**
     * 本地修改数量
     * @param {number} val
     * @param {number} subItemId
     * @param {number} [actType] 活动类型，兼容多件多折商品。默认不传
     * @returns
     */
    changeNumberLocal(val, subItemId, actType) {
      return (dispatch, getState) => {
        const { cartDuck } = getState()
        if (actType === ACTIVITY_TYPES.DISCOUNT) {
          dispatch(
            duck.merge({
              stepCollection: {
                entities: {
                  ...cartDuck.stepCollection.entities,
                  [subItemId]: {
                    ...cartDuck.stepCollection.entities[subItemId],
                    count: val,
                  },
                },
              },
            }),
          )
        } else {
          dispatch(
            duck.merge({
              productCollection: {
                entities: {
                  ...cartDuck.productCollection.entities,
                  [subItemId]: {
                    ...cartDuck.productCollection.entities[subItemId],
                    count: val,
                  },
                },
              },
            }),
          )
        }
      }
    },

    /**
     * 删除商品
     * @param {number} subItemId
     * @returns
     */
    delItem(subItemId) {
      return async dispatch => {
        Toast.loading('loading...')
        const { error } = await delItem({
          subItemIds: [subItemId],
          shopId: SHOP_ID,
        })
        if (!error) {
          dispatch(duck.fetchCartData())
        } else {
          Toast.hide()
          alert(error.message || '删除商品失败')
        }
      }
    },

    /**
     * 消息通知
     */
    getNotify() {
      //getNotify
      return async dispatch => {
        const { error, data } = await getNotify()
        if (!error) {
          dispatch(
            duck.change({
              notifyInfo: { ...data },
            }),
          )
        }
      }
    },

    getRecommendData() {
      return async dispatch => {
        const { error, data } = await getRecommend(SHOP_ID)
        if (!error) {
          dispatch(
            duck.change({
              recommendList: data,
            }),
          )
        }
      }
    },

    /**
     * 将换购商品添加到换购购物车里
     */
    addToActCart(param) {
      return async dispatch => {
        const { error } = await modifyActGoods(param)
        if (!error) {
          dispatch(duck.fetchCartData())
        } else {
          Toast.info((error && error.message) || '添加失败')
        }
      }
    },
    /**
     * 删除活动购物车商品
     */
    delActGoods(param) {
      return async dispatch => {
        const { error } = await removeActGoods(param)
        if (!error) {
          dispatch(duck.fetchCartData())
        }
      }
    },
  },
})
